var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-book-paper-map"},[_c('client-only',[_c('leaflet-map',{attrs:{"map-style":"outdoor","geo-jsons":_vm.geoJsons,"clustered":false,"track-location":false,"options":{ rounded: true }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }